export const MAP_PANEL_TITLE = "Map Controls";

export const MAP_PANEL_SUBTITLE = "API-driven polygon and point layers for store recommendation analysis.";

export const STATE_OPTIONS = [
	"All India",
	"Andhra Pradesh",
	"Assam",
	"Bihar",
	"Delhi",
	"Gujarat",
	"Haryana",
	"Karnataka",
	"Maharashtra",
	"Punjab",
	"Rajasthan",
	"Tamil Nadu",
	"Telangana",
	"Uttar Pradesh",
	"West Bengal",
];

export const LAYER_OPTIONS = [
	{ key: "STATE_BORDERS", label: "State Borders", kindLabel: "State borders" },
	{ key: "MASTER_POLYGONS", label: "Master Polygons", kindLabel: "Master polygons" },
	{ key: "ONLINE_POLYGONS", label: "Online Polygons", kindLabel: "Online polygons (unassigned)" },
	{ key: "SKATER_POLYGONS", label: "SKATER Polygons", kindLabel: "SKATER polygons (regions)" },
	{ key: "STORE_EBO_POINTS", label: "Store Points EBO", kindLabel: "Store points EBO" },
	{ key: "STORE_MBO_POINTS", label: "Store Points MBO", kindLabel: "Store points MBO" },
	{ key: "STORE_LFS_POINTS", label: "Store Points LFS", kindLabel: "Store points LFS" },
	{ key: "COMPETITOR_POINTS", label: "Competitor Points", kindLabel: "Competitor points" },
];

export const COLOR_MODES = [
	{
		key: "cluster",
		label: "Cluster Colors",
		legendType: "note",
		legendNote: "SKATER polygons use their stable cluster colors. Master polygons keep a neutral base style.",
	},
	{
		key: "hue",
		label: "Score Hue",
		legendType: "scale",
		legendTitle: "Region Score",
		minLabel: "Low",
		maxLabel: "High",
	},
	{
		key: "priority",
		label: "Priority Heat",
		legendType: "scale",
		legendTitle: "Priority Score",
		minLabel: "Low",
		maxLabel: "High",
	},
	{
		key: "coverage",
		label: "Store Coverage",
		legendType: "steps",
		steps: [
			{ color: "#d9d9d9", label: "0 store types present" },
			{ color: "#fee08b", label: "1 store type present" },
			{ color: "#f46d43", label: "2 store types present" },
			{ color: "#1a9850", label: "3+ store types present" },
		],
	},
];

export const HUE_PALETTES = [
	{
		key: "rdylgn",
		label: "Red -> Green",
		colors: ["#d73027", "#f46d43", "#fee08b", "#a6d96a", "#1a9850"],
	},
	{
		key: "ylorrd",
		label: "Yellow -> Red",
		colors: ["#ffffb2", "#fecc5c", "#fd8d3c", "#f03b20", "#bd0026"],
	},
	{
		key: "ylgn",
		label: "Yellow -> Green",
		colors: ["#ffffcc", "#c2e699", "#78c679", "#31a354", "#006837"],
	},
	{
		key: "bupu",
		label: "Blue -> Purple",
		colors: ["#edf8fb", "#bfd3e6", "#9ebcda", "#8c96c6", "#88419d"],
	},
	{
		key: "viridis",
		label: "Viridis",
		colors: ["#440154", "#3b528b", "#21918c", "#5ec962", "#fde725"],
	},
];

export const REGION_SUBSET_OPTIONS = [
	{ key: "all", label: "All Regions" },
	{ key: "top100", label: "Top 100 Only" },
	{ key: "bottom100", label: "Bottom 100" },
];

export const PRESET_OPTIONS = [
	{ key: "all", label: "Everything" },
	{ key: "master", label: "Master Only" },
	{ key: "skater", label: "SKATER Only" },
];

export const SUMMARY_CARDS = [
	{ label: "World Base", value: "Ready" },
	{ label: "Master Layer", value: "API" },
	{ label: "SKATER Layer", value: "API" },
	{ label: "Online Layer", value: "API" },
	{ label: "Point Layers", value: "API" },
];

export const DEFAULT_LAYERS = {
	STATE_BORDERS: true,
	MASTER_POLYGONS: true,
	ONLINE_POLYGONS: false,
	SKATER_POLYGONS: true,
	STORE_EBO_POINTS: false,
	STORE_MBO_POINTS: false,
	STORE_LFS_POINTS: false,
	COMPETITOR_POINTS: false,
};

export const DEFAULT_FILTER_OBJ = {
	stateQuery: "",
	competitorQuery: "",
	selectedStates: ["All India"],
	selectedCompetitorBrands: [],
	regionSubset: "all",
	colorMode: "cluster",
	palette: "rdylgn",
	layers: DEFAULT_LAYERS,
};
